import { Link } from "react-router-dom"
import "./PrivatePrescriptionsPage.css"

const services = [
  { name: "Competitive Pricing", description: "We offer competitive rates on all veterinary medications" },
  { name: "Wide Range", description: "Access to a broad range of veterinary prescription medications" },
  { name: "Expert Advice", description: "Professional guidance from our qualified pharmacists on pet medications" },
  { name: "Convenient Service", description: "Quick turnaround for most veterinary prescriptions" },
  { name: "All Animals", description: "Prescriptions for dogs, cats, horses, farm animals, and exotic pets" },
]

const faqs = [
  {
    question: "What is a veterinary prescription?",
    answer: "A veterinary prescription is a written instruction from your vet authorising medication for your pet or animal. We can dispense these prescriptions, often at more competitive prices than buying directly from your vet."
  },
  {
    question: "How does the service work?",
    answer: "Simply bring in your veterinary prescription from your vet, or ask your vet to send it to us. We'll dispense the medication and provide guidance on administration. Most prescriptions can be fulfilled the same day or next day."
  },
  {
    question: "What medications can you dispense?",
    answer: "We can dispense most veterinary prescription medications including flea and worm treatments, pain relief, antibiotics, chronic condition medications, and specialist treatments. If we don't have something in stock, we can usually order it quickly."
  },
  {
    question: "How much does it cost?",
    answer: "Our veterinary prescription prices are competitive with online pharmacies, and often cheaper than buying directly from your vet. We're happy to provide quotes before you commit, so you can compare prices."
  },
  {
    question: "Do I need to bring anything?",
    answer: "Please bring the original veterinary prescription from your vet. The prescription must include your pet's details, the medication required, dosage instructions, and your vet's signature. We cannot dispense without a valid prescription."
  },
  {
    question: "Can you dispense for all types of animals?",
    answer: "Yes, we can dispense veterinary prescriptions for all animals including dogs, cats, rabbits, horses, farm animals, and exotic pets. Just bring in your valid prescription from a registered veterinary surgeon."
  },
]

function PrivatePrescriptionsPage() {
  return (
    <div className="private-prescriptions-page">
      <section className="pp-hero">
        <h1>Veterinary Prescriptions</h1>
        <p className="pp-tagline">
          Competitive prices on medications for your pets and animals
        </p>
      </section>

      <section className="pp-intro">
        <p>
          We dispense veterinary prescriptions at competitive prices, helping you save money
          on your pet's medications without compromising on quality or service.
        </p>
        <p>
          Whether your furry friend needs regular flea treatment, ongoing medication for a
          chronic condition, or a one-off prescription, we're here to help.
        </p>
        <p className="pp-highlight">
          Competitive pricing — often cheaper than buying from your vet.
        </p>
      </section>

      <section className="pp-services">
        <h2>Why Choose Our Service</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M8 12h8" />
                  <path d="M12 8v8" />
                </svg>
              </div>
              <h3>{service.name}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="pp-cta">
        <h2>Ready to Get Started?</h2>
        <p>
          Bring in your veterinary prescription or give us a call to check our prices.
          We're happy to provide quotes so you can compare.
        </p>
        <Link to="/services?service=veterinary-prescriptions" className="button primary">
          Contact Us
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </Link>
      </section>

      <section className="pp-faq">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <h3>{faq.question}</h3>
              <p>{faq.answer}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default PrivatePrescriptionsPage
